/*
 * IMPORT
 */
import 'mapbox-gl/dist/mapbox-gl.css' // Npm: Mapbox css.
import React from 'react' // Npm: React.
import { Provider } from 'react-redux' // Npm: Redux provider.
import { ErrorBoundary } from 'react-error-boundary' // Npm: React error boundary.
import { PersistGate } from 'redux-persist/integration/react' // Npm: Redux persist gate.
import { ChakraProvider } from '@chakra-ui/react' // Npm: Chakra UI provider.
import { BrowserRouter as Router } from 'react-router-dom' // Npm: React router dom library.
import { createRoot } from 'react-dom/client'; // Npm: React dom client.


/*
 * PACKAGES
 */
import 'iife'
import theme from 'theme'
import Redux, { Persist } from 'store'


/*
 * SIBLINGS
 */
import App from 'index.app.js'
import ErrorComponent from 'index.error.js'


/*
 * STYLES
 */
import 'index.style.css'



/*
 * FIXES
 */
if ('production' === process.env.NODE_ENV) console.log = console.warn = console.error = () => { }


/*
 * RENDER
 */
createRoot(document.getElementById('root')).render(
  <ErrorBoundary fallback={<ErrorComponent />}>
    <Provider store={Redux}>
      <PersistGate persistor={Persist}>
        <ChakraProvider theme={theme}>
          <Router>
            <App isAnimating />
          </Router>
        </ChakraProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>
)
